var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Dashboard"}},[_c('SideMenu'),_c('div',{staticClass:"content_sections"},[_c('Sections',{attrs:{"option":'Default'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }